import React from "react";
import {loaderBallImage, transparentSquareImage} from "../../Utils/embedImages";

interface LoaderProps {
    showProgress?: boolean,
    showTransparentImage?: boolean,
    showBall?: boolean,
    isPositionAbsolute?: boolean,
    progress?: number,
    isLoaded: boolean,
    background?: string,
    onLoad?: (data: any) => void,
    data?: any
}

const Loader: React.FC<LoaderProps> = ({
                                           showProgress = false,
                                           showTransparentImage = false,
                                           showBall = true,
                                           isPositionAbsolute = true,
                                           progress,
                                           isLoaded,
                                           background = '#efefef',
                                           onLoad,
                                           data
                                       }) => {

    return (
        <div className={`sl-loader-ball ${isLoaded ? 'loaded' : ''}`}
             style={isPositionAbsolute ? {position: 'absolute'} : {position: 'relative'}}>
            {showTransparentImage ?
                (<img src={transparentSquareImage} className={'img-fluid'} style={isLoaded ? {position: "absolute"} : {}}
                      onLoad={() => {
                          if (onLoad) {
                              onLoad(data)
                          }
                      }}/>) : ''
            }
            <div className={'inner-container'} style={{background: background}}>
                {
                    showBall ?
                    (<img src={loaderBallImage} className={'ball'}/>) : ''
                }
                <span className={'progress'} style={{display: showProgress && ((typeof progress === 'undefined' ? 0 : progress) > 0 && (typeof progress === 'undefined' ? 0 : progress) < 100) ? 'initial' : 'none'}}>
                        <span className={'inner'} style={{width: `${progress}%`}}></span>
                </span>

                <div className="progress progress-striped2 active" style={{display: showProgress && ((typeof progress === 'undefined' ? 0 : progress) == 100 || (typeof progress === 'undefined' ? 0 : progress) == 0) ? 'initial' : 'none'}}>
                    <div role="progressbar" className="progress-bar progress-bar-sl"></div>
                </div>
            </div>
        </div>
    )
}

export default Loader;